var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19614)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7 12.2C13.3075 12.2 12.2 13.3075 12.2 14.7V33.5C12.2 34.8925 13.3075 36 14.7 36H33.5C34.8925 36 36 34.8925 36 33.5V14.7C36 13.3075 34.8925 12.2 33.5 12.2H14.7ZM10 14.7C10 12.0925 12.0925 10 14.7 10H33.5C36.1075 10 38.2 12.0925 38.2 14.7V33.5C38.2 36.1075 36.1075 38.2 33.5 38.2H14.7C12.0925 38.2 10 36.1075 10 33.5V14.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 24.1001V32.1001H17V24.1001H19.2Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 16.1001V32.1001H23V16.1001H25.2Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2 22.1001V32.1001H29V22.1001H31.2Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartLight);
export default __webpack_public_path__ + "static/media/icon_chart_light.22c15808.svg";
export { ForwardRef as ReactComponent };